import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function selectedLanguage(
  state = initialState.selectedLanguage,
  action
) {
  switch (action.type) {
    case types.CHANGE_LANGUAGE:
      return action.payload;
    default:
      return state;
  }
}
